module.exports = __webpack_public_path__ + "img/w11-b4.96683c8b.jpg";